import React from 'react'

const Loading = () => {
    return (
        <div className="flex flex-col items-center h-full text-center">
            <img src={`${process.env.PUBLIC_URL}/Capacut.webp`} alt="Logo de Capacut" className="w-32 mb-10" />
            <div className="flex items-center space-x-2">
                <p className="text-lg mr-3">Cargando, por favor espere</p>
                <svg
                    className="h-5 w-5 animate-spin text-gray-600"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="3"
                    />
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                </svg>
            </div>
        </div>
    )
}

export default Loading